import { Card, message, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import API from "../../../../../services/api-request";
import dayjs from "dayjs";

const PaymentHistory = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const pagination = {
    current: page,
    pageSize: 5,
    total: totalData,
    onChange: (page, limit) => {
      pagination.current = page;
      pagination.pageSize = limit;
      setPage(page);
    },
  };

  const getInvoice = async () => {
    setData([]);

    setLoading(true);
    API.Post(`invoice/list?page=${page}&limit=5`)
      .then((res) => {
        setTotalData(res?.data?.data?.totalItems);

        const formatSelect = res?.data?.data?.data?.map((item, index) => {
          return {
            ...item,
            no: page * 5 + index + 1,
          };
        });
        setData(formatSelect);
      })
      .catch((err) => {
        setData([]);
        message.info(`${err?.response?.data?.error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getInvoice();
  }, [page]);

  const columns = [
    {
      title: "Transaction ID",
      dataIndex: "invoice_number",
      key: "invoice_number",
      render: (invoice_number) => (invoice_number ? invoice_number : "-"),
    },
    {
      title: "Tanggal Outbound",
      dataIndex: "invoice_items",
      key: "invoice_items",
      render: (invoice_items) =>
        invoice_items[0]?.outbound_date
          ? dayjs(invoice_items[0]?.outbound_date).format("DD-MM-YYYY HH:mm")
          : "-",
    },
    {
      title: "Nama Pelanggan",
      dataIndex: "client",
      key: "client",
      render: (client) => (client ? client?.name : "-"),
    },
    {
      title: "Total Biaya",
      dataIndex: "amount",
      key: "amount",
      render: (amount) =>
        amount ? `Rp. ${amount.toLocaleString("id-ID")}` : "-",
    },
    {
      title: "Waktu Pembayaran",
      dataIndex: "paid_at",
      key: "paid-at",
      render: (paid_at) =>
        paid_at ? dayjs(paid_at).format("DD-MM-YYYY HH:mm") : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        return status === "unpaid" ? (
          <Tag color="red">{"Gagal Bayar"}</Tag>
        ) : status === "pending" ? (
          <Tag color="orange">{"Belum Bayar"}</Tag>
        ) : (
          <Tag color="green">{"Lunas"}</Tag>
        );
      },
    },
  ];

  return (
    <>
      <Card style={{ padding: 4 }}>
        <h3>Payment History</h3>
        <Table
          rowKey={(dataSource) => dataSource.invoice_number}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={pagination}
          style={{ width: "100%" }}
          scroll={{ x: 900 }}
        />
      </Card>
    </>
  );
};

export default PaymentHistory;
